import React from "react";
import Card from "../../../Helper/CardWrapper/cardWrapper";
import ContentGrid from "../../../Helper/gridWrapper/gridWrapper";
import { connect } from "react-redux";
import OrdersTable from "./OrdersTable";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { bindActionCreators } from "redux";
import {
  enableDisableForm,
  getExportOrders,
  getFormDetails,
} from "../../../Actions/orderAction";
import Alert from "../../../Helper/SimpleAlert/alert";
import { audioFunc } from "../../../Service/helper";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { Badge, Button, TextField, Typography } from "@material-ui/core";
import excel_icon from "./../../../images/excel_icon.png";
import ReactExport from "react-data-export";
import "bootstrap-daterangepicker/daterangepicker.css";
import isEqual from "lodash.isequal";
import Switch from "react-switch";
import {
  toggleDrawer,
  togglePopUp,
  selectedChat,
  clearData,
  increaseMessageIndex,
  setInitial,
  unreadCountToZero,
} from "../../../Actions/messagesAction";
import { ws } from "../../../App";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const momentTz = require("moment-timezone");

const styles = (theme) => ({
  headLine: {
    fontSize: 30,
    fontWeight: 500,
  },
  margin: {
    margin: theme.spacing.unit * 4,
  },
  customBadge: {
    backgroundColor: "#fff",
    color: "black",
    fontSize: "12px",
  },
});
class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      checked: false,
      hiddenSwitch: true,
      exportData: [],
      isToDownloadExcel: false,
      startDate: moment().format("MM/DD/YYYY"),
      endDate: "",
      isEnabledExportOrder: false,
      showNotification: false,
    };

    this.getExportOrdersTimer = null;
  }
  /* MARK :- Enable Disable Menu for Jotform */
  handleChange = () => {
    this.setState((prevState) => {
      var dict = {};
      var msg = "";

      audioFunc(true, false, "");

      if (!prevState.checked == true) {
        dict["properties"] = { status: "Enabled" };
        msg = "You have enabled your menu.";
      } else if (!prevState.checked == false) {
        dict["properties"] = { status: "Disabled" };
        msg = "You have disabled your menu.";
      }

      this.props
        .enableDisableForm(
          `https://api.jotform.com/form/${this.props.user.BusinessUser.OnlineOrderFormId}/properties?apiKey=09ec9741da1cb60e6cf174b550577672`,
          JSON.stringify(dict)
        )
        .then(() => {
          this.setState({
            showSuccess: true,
            showError: false,
            msg: msg,
          });
        });

      return {
        checked: !prevState.checked,
      };
    });
  };

  handleNotificationChange = () => {
    const userId = this.props.user.AppUser.UserId;
    var msg = "";

    this.setState((prevState) => {
      if (!prevState.showNotification == true) {
        this.props.togglePopUp(true);
        msg = "You have enabled messages.";

        this.setState({
          showSuccess: true,
          showError: false,
          msg: msg,
        });
      } else if (!prevState.showNotification == false) {
        this.props.togglePopUp(false);
        msg = "You have disabled messages.";

        this.setState({
          showSuccess: false,
          showError: true,
          msg: msg,
        });
      }

      localStorage.setItem(
        "NotificationShow" + userId,
        !prevState.showNotification
      );
      return {
        showNotification: !prevState.showNotification,
      };
    });
  };
  alertCallback = () => {
    this.setState({
      showError: false,
      showSuccess: false,
    });
  };

  componentDidMount() {
    const userId = this.props.user.AppUser.UserId;
    const status = localStorage.getItem("NotificationShow" + userId);
    if (status !== null) {
      this.setState({ showNotification: String(status) == "true" });
      this.props.togglePopUp(String(status) == "true");
    }
    this.setState({
      startDate: moment().subtract(6, "days").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY"),
    });

    this.displayDate();

    this.callGetOrderByDateRange(
      moment().subtract(6, "days").format("MM/DD/YYYY"),
      moment().add(1, "days").format("MM/DD/YYYY"),
      ""
    );

    this.callGetFormDetails();
  }

  componentDidUpdate(nextProps, prevState) {
    if (localStorage.getItem("UserId") !== null) {
      if (!isEqual(nextProps.exportOrders, this.props.exportOrders)) {
        this.getExportOrdersTimer = setInterval(() => {
          this.callGetOrderByDateRange(
            this.state.startDate,
            this.state.endDate,
            this.state.selectedDropDownvalue
          );
        }, 60000);
      }
    } else {
      clearInterval(this.getExportOrdersTimer);

      const { userData } = this.props;
      if (userData !== undefined) {
        userData.remove("user");
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    //this is called to before render method

    /* MARK :- For All Data Export */
    if (nextProps.exportOrders) {
      let valuesArrExportObj = [];
      let orderTotalAmount = 0;
      let tipTotalAmount = 0;
      let salesTotalAmount = 0;
      let comissionTotalAmount = 0;
      let commissionRate = 0;
      {
        nextProps.exportOrders &&
          nextProps.exportOrders.length > 0 &&
          nextProps.exportOrders
            .slice(0, nextProps.exportOrders.length)
            .map((order, index) => {
              let obj = nextProps.exportOrders[index].answers;
              let created_at = nextProps.exportOrders[index].created_at;
              commissionRate = nextProps.exportOrders[index].commission_rate;
              var dict = {};
              let orderDetails = [];
              let subTotal = "";
              let timeZone = "";
              let created_date_time;
              let prettyFormat = "";

              let onlineOrderFormType =
                this.props.user.BusinessUser.OnlineOrderFormType;

              Object.keys(obj).map(function (key) {
                let value = obj[key];

                if (
                  value.type !== "control_button" &&
                  value.type !== "control_head" &&
                  value.type !== "control_image"
                ) {
                  //orderType
                  if (value.name === "pickupdelivery") {
                    dict["orderType"]  = (value.answer === "doordash_delivery" ? 'DoorDash Delivery' : value.answer);
                  }

                  //Firstname, Lastname
                  if (value.name === "name") {
                    dict["Name"] = value.prettyFormat ? value.prettyFormat : "";
                    dict["FirstName"] =
                      onlineOrderFormType === "jotform"
                        ? value.answer !== null &&
                          value.answer !== undefined &&
                          value.answer !== ""
                          ? value.answer.first
                            ? value.answer.first
                            : ""
                          : ""
                        : value.prettyFormat.split(" ")[0];
                    dict["LastName"] =
                      onlineOrderFormType === "jotform"
                        ? value.answer !== null &&
                          value.answer !== undefined &&
                          value.answer !== ""
                          ? value.answer.last
                            ? value.answer.last
                            : ""
                          : ""
                        : value.prettyFormat.split(" ")[1];
                  }

                  //Email
                  if (value.name === "email") {
                    if (value.answer) {
                      dict["Email"] = value.answer ? value.answer : "";
                    }
                  }

                  //phoneNumber
                  if (value.name === "phoneNumber") {
                    dict["PhoneNumber"] = value.prettyFormat
                      ? value.prettyFormat
                      : "";
                  }

                  //CreatedDateTime TimeZone
                  if (value.name === "scheduleDeliveryFor") {
                    if (value.answer !== null && value.answer !== undefined) {
                      timeZone = value.answer["timezone"];
                    } else if (
                      value.answers !== null &&
                      value.answers !== undefined
                    ) {
                      timeZone = value.answers["timezone"];
                    }
                  } else if (value.name === "schedulePickupFor") {
                    if (value.answer !== null && value.answer !== undefined) {
                      timeZone = value.answer["timezone"];
                    } else if (
                      value.answers !== null &&
                      value.answers !== undefined
                    ) {
                      timeZone = value.answers["timezone"];
                    }
                  }

                  // orderDetails
                  if (value.name === "orderDetails") {
                    prettyFormat = value.prettyFormat;
                    let obj1 = "";
                    if (value.answers !== null && value.answers !== undefined) {
                      obj1 = value.answers;
                    } else {
                      obj1 = value.answer;
                    }
                    orderDetails.push({
                      obj1,
                    });
                  }
                  orderDetails.map((orderDetailsObj, index) => {
                    let obj2 = orderDetails[index]["obj1"];

                    let objAns = "";
                    if (onlineOrderFormType !== "jotform") {
                      objAns = obj2["ans"];
                    }

                    if (obj2 !== undefined) {
                      let arrPayment = JSON.parse(obj2["paymentArray"]);

                      if (arrPayment !== "" && arrPayment !== undefined) {
                        if (arrPayment.subtotal !== undefined) {
                          subTotal = (
                            Math.round(arrPayment.subtotal * 100) / 100
                          ).toFixed(2);
                        }
                        if (arrPayment.tax !== undefined) {
                          dict["Tax"] = (
                            Math.round(arrPayment.tax * 100) / 100
                          ).toFixed(2);
                        }
                      }

                      if (onlineOrderFormType !== "jotform") {
                        obj2 = objAns;
                      }

                      let productName = "";
                      Object.keys(obj2).map(function (key) {
                        let data = "";

                        try {
                          // Parse a JSON
                          data =
                            objAns !== null &&
                            objAns !== undefined &&
                            objAns !== ""
                              ? obj2[key]
                              : JSON.parse(obj2[key]);
                        } catch (e) {
                          data = "";
                        }

                        if (
                          data.name === "Tip" &&
                          data.options !== undefined &&
                          data.options !== ""
                        ) {
                          var SampleText = data.options[0].selected.toString();
                          var NewText = SampleText.replace("$", "");
                          dict["Tip"] = (
                            Math.round(NewText * 100) / 100
                          ).toFixed(2);
                        }

                        if (
                          data !== "" &&
                          data !== undefined &&
                          data.name !== "" &&
                          data.name !== undefined &&
                          data.name !== "Tip"
                        ) {
                          let options = "";

                          Object.keys(data.options).map(function (key) {
                            let dataOptions = data.options[key]; //JSON.parse()
                            if (dataOptions.name !== "Quantity") {
                              var dat =
                                dataOptions.price !== null &&
                                dataOptions.price !== undefined &&
                                dataOptions.price !== ""
                                  ? dataOptions.name +
                                    " - " +
                                    dataOptions.selected +
                                    " : " +
                                    "$" +
                                    dataOptions.price
                                  : dataOptions.selected;
                              if (options === "") {
                                options = "With: " + dat;
                              } else {
                                options = options + ", With: " + dat;
                              }
                            }
                          });

                          if (productName === "") {
                            productName = data.name;
                          } else {
                            productName = productName + "\n\n" + data.name;
                          }
                          if (data.price !== undefined && data.price !== "") {
                            productName =
                              productName +
                              "(Amount: $" +
                              (Math.round(data.price * 100) / 100).toFixed(2);
                            if (
                              data.quantity !== undefined &&
                              data.quantity !== ""
                            ) {
                              productName =
                                productName + ", Quantity:" + data.quantity;

                              if (options !== undefined && options !== "") {
                                productName =
                                  productName + ", " + options + ")";
                              } else {
                                productName = productName + ")";
                              }
                            } else {
                              if (options !== undefined && options !== "") {
                                productName =
                                  productName + ", " + options + ")";
                              } else {
                                productName = productName + ")";
                              }
                            }
                          } else if (
                            data.quantity !== undefined &&
                            data.quantity !== ""
                          ) {
                            productName =
                              productName + "(Quantity:" + data.quantity;

                            if (options !== undefined && options !== "") {
                              productName = productName + ", " + options + ")";
                            } else {
                              productName = productName + ")";
                            }
                          } else {
                            if (options !== undefined && options !== "") {
                              productName = productName + ", " + options + ")";
                            } else {
                              productName = productName + ")";
                            }
                          }
                        }
                      });
                      dict["orderDetails"] = productName;
                    }
                  });

                  if (value.type === "control_textarea") {
                    if (value.answer) {
                      dict["Notes"] = value.answer ? value.answer : "";
                    }
                  }

                  if (value.name === "total") {
                    dict["Total"] =
                      value.answer !== undefined && value.answer !== ""
                        ? value.answer
                        : "-";
                    if (orderTotalAmount === 0 && dict["Total"] !== "-") {
                      var SampleText = dict["Total"].toString();
                      var NewText = SampleText.replace("$", "");
                      orderTotalAmount = parseFloat(NewText);
                    } else if (dict["Total"] !== "-") {
                      var SampleText = dict["Total"].toString();
                      var NewText = SampleText.replace("$", "");
                      orderTotalAmount = orderTotalAmount + parseFloat(NewText);
                    }
                  }
                }
              });

              // Commission amount calculation
              var totalAmount = 0;
              var tipAmount = 0;
              var salesTax = 0;
              if (
                dict["Total"] !== undefined &&
                dict["Total"] !== "" &&
                dict["Total"] !== "-"
              ) {
                var SampleText = dict["Total"].toString();
                var NewText = SampleText.replace("$", "");
                totalAmount = (Math.round(NewText * 100) / 100).toFixed(2);
              }
              if (dict["Tip"] !== undefined && dict["Tip"] !== "") {
                tipAmount = dict["Tip"];
              }
              if (dict["Tax"] !== undefined && dict["Tax"] !== "") {
                salesTax = dict["Tax"];
              }
              dict["comissionAmount"] =
                (totalAmount - tipAmount - salesTax) * (commissionRate/100);
              if (
                comissionTotalAmount === 0 &&
                dict["comissionAmount"] !== ""
              ) {
                comissionTotalAmount = parseFloat(dict["comissionAmount"]);
              } else if (dict["comissionAmount"] !== "") {
                comissionTotalAmount =
                  comissionTotalAmount + parseFloat(dict["comissionAmount"]);
              }

              // order Created Date-time
              if (timeZone !== undefined && timeZone !== "") {
                if (onlineOrderFormType === "jotform") {
                  timeZone = timeZone.split(" ")[0];
                  var dateTimeInUtc = momentTz
                    .tz(created_at, "YYYY-MM-DD HH:mm:ss", "America/New_York")
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss");
                  created_date_time = moment
                    .utc(dateTimeInUtc, "YYYY-MM-DD HH:mm:ss")
                    .tz(timeZone)
                    .format("ddd, MMM Do h:mm A");
                } else {
                  created_date_time = moment
                    .utc(created_at)
                    .local()
                    .format("ddd, MMM Do h:mm A");
                }
              } else {
                if (onlineOrderFormType === "jotform") {
                  created_date_time = moment
                    .utc(created_at)
                    .format("ddd, MMM Do h:mm A");
                } else {
                  created_date_time = moment
                    .utc(created_at)
                    .local()
                    .format("ddd, MMM Do h:mm A");
                }
              }

              // Total Tip Calculation
              if (tipTotalAmount === 0) {
                tipTotalAmount = parseFloat(dict["Tip"]);
              } else {
                tipTotalAmount = tipTotalAmount + parseFloat(dict["Tip"]);
              }

              // Total SalesTax Calculation
              if (
                salesTotalAmount === 0 &&
                dict["Tax"] !== undefined &&
                dict["Tax"] !== ""
              ) {
                salesTotalAmount = parseFloat(dict["Tax"]);
              } else if (dict["Tax"] !== undefined && dict["Tax"] !== "") {
                salesTotalAmount = salesTotalAmount + parseFloat(dict["Tax"]);
              }

              var dictData;
              dictData = [
                { value: created_date_time, style: { font: { sz: "12" } } },
                { value: dict["orderType"], style: { font: { sz: "12" } } },
                { value: dict["FirstName"], style: { font: { sz: "12" } } },
                { value: dict["LastName"], style: { font: { sz: "12" } } },
                { value: dict["Email"], style: { font: { sz: "12" } } },
                { value: dict["PhoneNumber"], style: { font: { sz: "12" } } },
                {
                  value: dict["orderDetails"],
                  style: { font: { sz: "12" }, alignment: { wrapText: true } },
                },
                {
                  value: dict["Total"],
                  style: {
                    font: { bold: true, sz: "12", color: { rgb: "00b050" } },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  },
                },
                {
                  value: dict["Tip"] !== undefined ? "$" + dict["Tip"] : "",
                  style: {
                    font: { bold: true, sz: "12", color: { rgb: "00b050" } },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  },
                },
                {
                  value: dict["Tax"] !== undefined ? dict["Tax"] : "",
                  style: {
                    font: { bold: true, sz: "12", color: { rgb: "FF0000" } },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  },
                },
                {
                  value:
                    dict["comissionAmount"] !== undefined
                      ? "$" + dict["comissionAmount"].toFixed(2)
                      : "",
                  style: {
                    font: { bold: true, sz: "12", color: { rgb: "FF0000" } },
                    alignment: {
                      horizontal: "center",
                      vertical: "center",
                      wrapText: true,
                    },
                  },
                },
              ];

              valuesArrExportObj.push(dictData);
            });

        for (var i = 0; i < 4; i++) {
          var dictData1 = {};
          dictData1 = [
            { value: "", style: { font: { sz: "12" } } },
            { value: "", style: { font: { sz: "12" } } },
            { value: "", style: { font: { sz: "12" } } },
            { value: "", style: { font: { sz: "12" } } },
            { value: "", style: { font: { sz: "12" } } },
            { value: "", style: { font: { sz: "12" } } },
            {
              value: "",
              style: { font: { sz: "12" }, alignment: { wrapText: true } },
            },
            {
              value:
                i === 2
                  ? "Total Orders:"
                  : i === 3
                  ? "$" + (Math.round(orderTotalAmount * 100) / 100).toFixed(2)
                  : "",
              style: {
                font: { bold: true, sz: "12", color: { rgb: "00b050" } },
                alignment: {
                  horizontal: "center",
                  vertical: "center",
                  wrapText: true,
                },
              },
            },
            {
              value:
                i === 2
                  ? "Total Tips:"
                  : i === 3
                  ? "$" + (Math.round(tipTotalAmount * 100) / 100).toFixed(2)
                  : "",
              style: {
                font: { bold: true, sz: "12", color: { rgb: "00b050" } },
                alignment: {
                  horizontal: "center",
                  vertical: "center",
                  wrapText: true,
                },
              },
            },
            {
              value:
                i === 2
                  ? "Total Sales Tax:"
                  : i === 3
                  ? "$" + (Math.round(salesTotalAmount * 100) / 100).toFixed(2)
                  : "",
              style: {
                font: { bold: true, sz: "12", color: { rgb: "FF0000" } },
                alignment: {
                  horizontal: "center",
                  vertical: "center",
                  wrapText: true,
                },
              },
            },
            {
              value:
                i === 2
                  ? "Total Commission:"
                  : i === 3
                  ? "$" +
                    (Math.round(comissionTotalAmount * 100) / 100).toFixed(2)
                  : "",
              style: {
                font: { bold: true, sz: "12", color: { rgb: "FF0000" } },
                alignment: {
                  horizontal: "center",
                  vertical: "center",
                  wrapText: true,
                },
              },
            },
          ];

          valuesArrExportObj.push(dictData1);
        }

        const multiDataSet = [
          {
            columns: [
              {
                title: "Order Date",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Order Type",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "First Name",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Last Name",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Email",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Phone number",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Order Details",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11" },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Order Total",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11", color: { rgb: "00b050" } },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Tip",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11", color: { rgb: "00b050" } },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: "Sales Tax",
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11", color: { rgb: "FF0000" } },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
              {
                title: `${commissionRate}% Comission`,
                width: { wpx: 150 },
                style: {
                  font: { bold: true, sz: "11", color: { rgb: "FF0000" } },
                  fill: { patternType: "solid", fgColor: { rgb: "BEFFC9" } },
                  alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                  },
                },
              },
            ],
            data: valuesArrExportObj,
          },
        ];

        let exportDat = multiDataSet;

        this.setState({
          exportData: exportDat,
        });
      }
    }

    /* MARK :- "Disable/Enable Jotform 'switch status' as per api response" */
    if (
      nextProps.form !== undefined &&
      nextProps.form.status == "DISABLED" &&
      this.state.hiddenSwitch == true
    ) {
      this.setState({
        checked: false,
        hiddenSwitch: false,
      });
    } else if (
      nextProps.form !== undefined &&
      nextProps.form.status == "ENABLED" &&
      this.state.hiddenSwitch == true
    ) {
      this.setState({
        checked: true,
        hiddenSwitch: false,
      });
    } else if (
      nextProps.form !== undefined &&
      this.state &&
      this.state.checked == true
    ) {
      this.setState({
        checked: true,
        hiddenSwitch: false,
      });
    } else if (
      nextProps.form !== undefined &&
      this.state &&
      this.state.checked == false
    ) {
      this.setState({
        checked: false,
        hiddenSwitch: false,
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.getExportOrdersTimer);
  }

  /* MARK :- Date Picker Event for Export Orders */
  handleEvent = (ev, picker) => {
    let startDate = `${picker.startDate.format("MM/DD/YYYY")}`;
    let endDate = picker.endDate.format("MM/DD/YYYY");
    let choosenLabel = picker.chosenLabel;
    if (choosenLabel === "Yesterday" || choosenLabel === "Last Month")
      endDate = `${endDate}`;
    else if (choosenLabel === "Custom Range") {
      if (endDate >= moment().format("MM/DD/YYYY")) {
        endDate = `${endDate}`;
      } else {
        endDate = `${endDate}`;
      }
    } else endDate = `${endDate}`;

    if (
      moment(startDate).format("MM/DD/YYYY") !==
      moment(endDate).format("MM/DD/YYYY")
    )
      this.setState({
        startDate,
        endDate,
      });
    else
      this.setState({
        startDate,
        endDate: "",
      });

    this.callGetOrderByDateRange(
      moment(startDate).format("MM/DD/YYYY"),
      moment(endDate).add(1, "days").format("MM/DD/YYYY"),
      this.state.selectedDropDownvalue
    );

    ev.preventDefault();
    ev.stopPropagation();
    console.log("display date", this.state.startDate, this.state.endDate);
  };

  displayDate = () => {
    let { endDate, startDate } = this.state;

    if (endDate === "") {
      return moment(startDate).format("MMM Do, YYYY").toString();
    } else if (
      moment(startDate).format("MMM Do, YYYY").split(" ")[0] ===
      moment(endDate).format("MMM Do, YYYY").split(" ")[0]
    ) {
      return `${
        moment(startDate).format("MMM Do, YYYY").split(",")[0]
      } - ${moment(endDate).format("MMM Do, YYYY").substring(4, 14)}`;
    } else if (
      moment(startDate).format("MMM Do, YYYY").split(" ")[0] !==
      moment(endDate).format("MMM Do, YYYY").split(" ")[0]
    ) {
      return `${
        moment(startDate).format("MMM Do, YYYY").split(",")[0]
      } - ${moment(endDate).format("MMM Do, YYYY").substring(0, 14)}`;
    }
  };

  callGetOrderByDateRange(startDate, endDate, selectedDropDownvalue) {
    if (startDate !== "" && endDate !== "") {
      clearInterval(this.getExportOrdersTimer);
      this.setState({
        isEnabledExportOrder: false,
      });
      if (
        selectedDropDownvalue !== undefined &&
        selectedDropDownvalue !== "" &&
        selectedDropDownvalue !== "All"
      ) {
        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
          this.props
            .getExportOrders(
              this.props.user.BusinessUser.OnlineOrderFormType,
              `https://api.jotform.com/form/${this.props.user.BusinessUser.OnlineOrderFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000&filter={"created_at:gt":"${startDate}","created_at:lt":"${endDate}","q${this.state.isActiveOrCompletedId}:matches":"${selectedDropDownvalue}"}`
            )
            .then(() => {
              this.getExportOrdersTimer = setInterval(() => {
                this.callGetOrderByDateRange(
                  this.state.startDate,
                  this.state.endDate,
                  this.state.selectedDropDownvalue
                );
              }, 60000);
              this.setState({
                isEnabledExportOrder: true,
              });
            });
        } else {
          let startDat = moment(startDate).format("MM-DD-YYYY");
          let endDat = moment(endDate).format("MM-DD-YYYY");
          let type =
            selectedDropDownvalue !== undefined && selectedDropDownvalue !== ""
              ? selectedDropDownvalue === "Active"
                ? "processing"
                : selectedDropDownvalue
              : "All";
          this.props
            .getExportOrders(
              this.props.user.BusinessUser.OnlineOrderFormType,
              `/GrabWordpressOrders/${this.props.user.BusinessUser.OnlineOrderFormId}/${type}/${startDat}/${endDat}`
            )
            .then(() => {
              this.getExportOrdersTimer = setInterval(() => {
                this.callGetOrderByDateRange(
                  this.state.startDate,
                  this.state.endDate,
                  this.state.selectedDropDownvalue
                );
              }, 60000);
              this.setState({
                isEnabledExportOrder: true,
              });
            });
        }
      } else {
        if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
          this.props
            .getExportOrders(
              this.props.user.BusinessUser.OnlineOrderFormType,
              `https://api.jotform.com/form/${this.props.user.BusinessUser.OnlineOrderFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000&filter={"created_at:gt":"${startDate}","created_at:lt":"${endDate}"}`
            )
            .then(() => {
              this.getExportOrdersTimer = setInterval(() => {
                this.callGetOrderByDateRange(
                  this.state.startDate,
                  this.state.endDate,
                  this.state.selectedDropDownvalue
                );
              }, 60000);
              this.setState({
                isEnabledExportOrder: true,
              });
            });
        } else {
          let startDat = moment(startDate).format("MM-DD-YYYY");
          let endDat = moment(endDate).format("MM-DD-YYYY");
          let type =
            selectedDropDownvalue !== undefined && selectedDropDownvalue !== ""
              ? selectedDropDownvalue === "Active"
                ? "processing"
                : selectedDropDownvalue
              : "All";
          this.props
            .getExportOrders(
              this.props.user.BusinessUser.OnlineOrderFormType,
              `/GrabWordpressOrders/${this.props.user.BusinessUser.OnlineOrderFormId}/${type}/${startDat}/${endDat}`
            )
            .then(() => {
              this.getExportOrdersTimer = setInterval(() => {
                this.callGetOrderByDateRange(
                  this.state.startDate,
                  this.state.endDate,
                  this.state.selectedDropDownvalue
                );
              }, 60000);
              this.setState({
                isEnabledExportOrder: true,
              });
            });
        }
      }
    }
  }

  callGetFormDetails() {
    if (this.props.user.BusinessUser.OnlineOrderFormType === "jotform") {
      this.props.getFormDetails(
        `https://api.jotform.com/form/${this.props.user.BusinessUser.OnlineOrderFormId}?apiKey=09ec9741da1cb60e6cf174b550577672`
      );
    } else {
    }
  }

  callbackFunction = (selectedDropDownvalue, isActiveOrCompletedId) => {
    this.setState(
      {
        selectedDropDownvalue: selectedDropDownvalue,
        isActiveOrCompletedId: isActiveOrCompletedId,
      },
      () => {
        this.callGetOrderByDateRange(
          moment(this.state.startDate).format("MM/DD/YYYY"),
          moment(this.state.endDate).add(1, "days").format("MM/DD/YYYY"),
          this.state.selectedDropDownvalue
        );
      }
    );
  };

  render() {
    const { classes } = this.props;
    const { exportData } = this.state;
    let count = this.props.messageData && this.props.messageData.unreadCount;

    const toExcel = () => {
      this.setState({
        isToDownloadExcel: true,
      });
      setTimeout(
        function () {
          this.setState({ isToDownloadExcel: false });
        }.bind(this),
        5000
      );
    };

    var today = new Date();
    var fileName =
      "Orders_" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate() +
      "-" +
      today.getFullYear();

    return (
      <div className="main-Div">
        {this.state.isToDownloadExcel && this.state.exportData && (
          <ExcelFile hideElement={true} filename={fileName}>
            <ExcelSheet dataSet={exportData} name="Orders" />
          </ExcelFile>
        )}

        <Grid container spacing={24}>
          <Alert
            onClose={this.alertCallback}
            showSuccess={this.state.showSuccess}
            showError={this.state.showError}
            Msg={this.state.msg}
          />
        </Grid>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          }}
        >
          <ContentGrid
            content={
              <Card
                content={
                  <Grid container style={{ padding: "3.5px" }}>
                    <Grid item style={{ marginTop: "-5px" }}>
                      <DateRangePicker
                        startDate={moment(this.state.startDate)}
                        endDate={
                          this.state.endDate === ""
                            ? moment(this.state.startDate)
                            : moment(this.state.endDate)
                        }
                        ranges={{
                          Today: [moment(), moment()],
                          Yesterday: [
                            moment().subtract(1, "days"),
                            moment().subtract(1, "days"),
                          ],
                          "Last 7 Days": [
                            moment().subtract(6, "days"),
                            moment(),
                          ],
                          "Last 30 Days": [
                            moment().subtract(29, "days"),
                            moment(),
                          ],
                        }}
                        showCustomRangeLabel={true}
                        alwaysShowCalendars={true}
                        opens={"center"}
                        drops={"down"}
                        onApply={this.handleEvent}
                        applyClass="apply-btn"
                        linkedCalendars={false}
                        dateLimit={{ days: "30" }}
                      >
                        <TextField
                          InputProps={{
                            className: classes.headerDate,
                          }}
                          inputProps={{
                            className: classes.headerDate,
                          }}
                          value={this.displayDate()}
                        />
                      </DateRangePicker>
                    </Grid>
                    <Grid
                      item
                      style={{ marginLeft: "auto", marginTop: "-5px" }}
                    >
                      {this.state.isEnabledExportOrder === true ? (
                        <div>
                          <img
                            src={excel_icon}
                            style={{
                              width: "20px",
                              height: "25px",
                              cursor: "pointer",
                              marginLeft: "10px",
                              display: "inline-block",
                            }}
                            onClick={() => toExcel()}
                          />
                          <label
                            style={{
                              fontSize: "13px",
                              margin: "0 6px 0 3px",
                              fontWeight: "normal",
                              cursor: "pointer",
                              display: "inline-block",
                              fontFamily: "Arial",
                              color: "#636363"
                            }}
                            onClick={() => toExcel()}
                          >
                            Export Orders
                          </label>
                        </div>
                      ) : (
                        <div>
                          <img
                            src={excel_icon}
                            style={{
                              width: "20px",
                              height: "25px",
                              cursor: "not-allowed",
                              pointerEvents: "all !important",
                              marginLeft: "10px",
                              display: "inline-block",
                            }}
                            disabled
                          />
                          <label
                            style={{
                              fontSize: "11px",
                              margin: "0 6px 0 3px",
                              fontWeight: "normal",
                              cursor: "not-allowed",
                              pointerEvents: "all !important",
                              display: "inline-block",
                            }}
                            disabled
                          >
                            Export Orders
                          </label>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                }
                CardContentProps={{
                  style: { paddingBottom: 5, width: this.props.width },
                }}
              />
            }
          />
          {this.props.user.BusinessUser.OnlineOrderFormType === "jotform" && (
            <ContentGrid
              content={
                <Card
                  content={
                    <Grid container>
                      <Grid item>
                        <div className="divDisableEnableMenuText">
                          <label style={{ fontSize: "13px", fontFamily: "Arial",fontWeight: "normal" }}>
                            Disable/Enable your menu:
                          </label>
                        </div>
                      </Grid>
                      {this.state.hiddenSwitch == false ? (
                        <Grid
                          item
                          className="got-it-btn"
                          style={{ marginLeft: "auto", marginTop: "-5px" }}
                        >
                          <div style={{ width: "105px", marginTop: "-2px" }}>
                            {this.state.checked == true ? (
                              <Grid
                                component="label"
                                container
                                alignItems="center"
                                spacing={1}
                              >
                                <Grid item>
                                  <Switch
                                    onLabel="ON"
                                    offLabel="OFF"
                                    onChange={this.handleChange}
                                    checked={this.state.checked}
                                    checkedIcon={false}
                                    uncheckedIcon={false}
                                    offColor="#E74C3C"
                                    onColor="#080"
                                  />
                                </Grid>
                                <Grid item style={{ marginTop: "-5px" }}>
                                  On
                                </Grid>
                              </Grid>
                            ) : (
                              <Grid
                                component="label"
                                container
                                alignItems="center"
                                spacing={1}
                              >
                                <Grid item style={{ marginTop: "-5px" }}>
                                  Off
                                </Grid>
                                <Grid item>
                                  <Switch
                                    onLabel="ON"
                                    offLabel="OFF"
                                    onChange={this.handleChange}
                                    checked={this.state.checked}
                                    checkedIcon={false}
                                    uncheckedIcon={false}
                                    offColor="#E74C3C"
                                    onColor="#080"
                                  />
                                </Grid>
                              </Grid>
                            )}
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                  }
                  CardContentProps={{
                    style: { paddingBottom: 5, width: this.props.width },
                  }}
                />
              }
            />
          )}
        </div>

        {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill,minmax(200px, 4fr))",
          }}
        > */}
        <Grid container>
          <Grid item xs={12} sm={8} md={8} lg={8}>
            <ContentGrid
              content={
                <Card
                  content={
                    <Grid container>
                      <Grid item>
                        <div className="divDisableEnableMenuText">
                          <label style={{ fontSize: "13px", fontFamily: "Arial",fontWeight: "normal" }}>
                            <b> Message Notifications </b> - This switch will allow UBMe app users to send you a message and get real-time feedback.
                          </label>
                        </div>
                      </Grid>
                      <Grid
                        item
                        className="got-it-btn"
                        style={{ marginLeft: "auto", marginTop: "-5px" }}
                      >
                        <div style={{ width: "105px", marginTop: "-2px" }}>
                          {this.state.showNotification == true ? (
                            <Grid
                              component="label"
                              container
                              alignItems="center"
                              spacing={1}
                            >
                              <Grid item>
                                <Switch
                                  onLabel="ON"
                                  offLabel="OFF"
                                  onChange={this.handleNotificationChange}
                                  checked={this.state.showNotification}
                                  checkedIcon={false}
                                  uncheckedIcon={false}
                                  offColor="#E74C3C"
                                  onColor="#080"
                                />
                              </Grid>
                              <Grid item style={{ marginTop: "-5px" }}>
                                On
                              </Grid>
                            </Grid>
                          ) : (
                            <Grid
                              component="label"
                              container
                              alignItems="center"
                              spacing={1}
                            >
                              <Grid item>
                                <Switch
                                  onLabel="ON"
                                  offLabel="OFF"
                                  onChange={this.handleNotificationChange}
                                  checked={this.state.showNotification}
                                  checkedIcon={false}
                                  uncheckedIcon={false}
                                  offColor="#E74C3C"
                                  onColor="#080"
                                />
                              </Grid>
                              <Grid item style={{ marginTop: "-5px" }}>
                                Off
                              </Grid>
                            </Grid>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  }
                  CardContentProps={{
                    style: { paddingBottom: 5, width: this.props.width },
                  }}
                />
              }
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <div style={{ flex: 1, display: "flex", marginLeft: "20px" }}>
              <Button
                variant="contained"
                fullWidth="true"
                style={{
                  backgroundColor: "#4CAF50",
                  borderRadius: 0,
                  marginTop: "20px",
                  height: "50px",
                  width: this.props.width,
                  // flex: 1,
                }}
                onClick={() => {
                  const messageData = this.props.messageData;

                  let data =
                    messageData &&
                    messageData.recentChat &&
                    messageData.recentChat[0];
                  const userId = this.props.user.AppUser.UserId;
                  if (data) {
                    this.props.unreadCountToZero(data.dialog_id);
                    this.props.clearData(data);

                    ws.json({
                      to_user_id: data.from_user_id,
                      type: "userstatus",
                    });

                    if (data.Type === "OneToOne") {
                      ws.json({
                        count: 10,
                        deleteCount: 0,
                        dialog_id: data.dialog_id,
                        index: 1,
                        type: "chatHistory",
                        user_id: userId,
                      });
                      this.props.setInitial("OneToOne");
                    } else {
                      ws.json({
                        chat_type:
                          data.Type === "PlaceQuestionChat"
                            ? "PlaceQuestionChat"
                            : data.Type === "Feed"
                            ? "Feed"
                            : "Event",
                        count: 20,
                        deleteCount: 0,
                        googlePlacedId: data.dialog_id,
                        index: 0,
                        requesterId: userId,
                        type: "businessrecentchat",
                        user_id: data.userid,
                      });
                      this.props.setInitial("QuestionChat");
                    }

                    if (messageData.selectedChat.dialog_id === data.dialog_id) {
                      this.props.increaseMessageIndex(
                        messageData.messageIndex + 1
                      );
                    } else {
                      this.props.increaseMessageIndex(
                        data.Type === "OneToOne" ? 2 : 1
                      );
                    }

                    this.props.selectedChat(data);
                  }

                  this.props.toggleDrawer(true, true);
                }}
              >
                <Badge
                  badgeContent={count}
                  classes={{ badge: classes.customBadge }}
                >
                  <Typography
                    variant="button"
                    component="div"
                    style={{
                      textTransform: "none",
                      marginRight: "10px",
                      fontSize: "12px",
                      color: "white",
                    }}
                  >
                    {"See All Messages "}
                  </Typography>
                </Badge>
              </Button>
            </div>
          </Grid>
        </Grid>
        {/* </div> */}
        <ContentGrid
          content={
            <Card
              header={"Orders"}
              CardHeaderProps={{
                classes: {
                  title: classes.headLine,
                },
              }}
              content={<OrdersTable parentCallback={this.callbackFunction} />}
              CardContentProps={{
                style: { borderTop: "1px solid #ddd" },
              }}
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.loginResponse.results,
    exportOrders: state.orderReducer.exportOrders,
    form: state.orderReducer.form,
    messageData: state.messageReducer,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getExportOrders,
      enableDisableForm,
      getFormDetails,
      toggleDrawer,
      togglePopUp,
      selectedChat,
      clearData,
      increaseMessageIndex,
      setInitial,
      unreadCountToZero,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withStyles(styles)(Orders));
